import type {
  EventChannel,
  EventsChannelFilterProps,
} from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/EventsChannelFilter/index.types';
import { CHANNEL_LABELS } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/EventsTab/index.constants';
import {
  chipClasses,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

const CHANNELS: { value: EventChannel; label: string; dot?: string }[] = [
  { value: null, label: 'All' },
  { value: 'SIP', label: CHANNEL_LABELS.SIP, dot: 'bg-sky-400' },
  { value: 'RTP', label: CHANNEL_LABELS.RTP, dot: 'bg-emerald-400' },
  { value: 'DEVICE', label: CHANNEL_LABELS.DEVICE, dot: 'bg-amber-400' },
  { value: 'CALL', label: CHANNEL_LABELS.CALL, dot: 'bg-violet-400' },
];

/**
 * EventsChannelFilter - Read signalling without the media noise
 *
 * Always present, unlike the per-leg filter.
 */
export const EventsChannelFilter: React.FC<EventsChannelFilterProps> = ({
  selected,
  onSelect,
  countsByChannel,
  total,
}) => (
  <div
    role="group"
    aria-label="Channel filter"
    className="flex flex-wrap items-center gap-1.5"
  >
    {CHANNELS.map(({ value, label, dot }) => {
      const isSelected = selected === value;
      const count = value === null ? total : countsByChannel[value];

      return (
        <button
          key={label}
          type="button"
          onClick={() => onSelect(value)}
          className={chipClasses(isSelected)}
        >
          {dot && <span className={cn('h-[5px] w-[5px] rounded-full', dot)} />}
          {label}
          <span className="font-sp-mono text-[10px] opacity-70">{count}</span>
        </button>
      );
    })}
  </div>
);
